import ComponentDescription from './ComponentDescription';

export default ComponentDescription;
